import type { FormEvent } from 'react';
import type { ChangePasswordFormCopy } from './models';
import { text } from './text_business_logic';

export type { ChangePasswordFormCopy } from './models';

export function getChangePasswordFormCopy(isSubmitting: boolean): ChangePasswordFormCopy {
  return text.changePasswordFormCopy(isSubmitting);
}

export function createChangePasswordFormSubmitHandler(onSubmit: () => void) {
  return (event: FormEvent) => {
    event.preventDefault();
    onSubmit();
  };
}

export function passwordsMatch(newPassword: string, confirmPassword: string): boolean {
  return newPassword === confirmPassword;
}
